<template>
  <validation-observer v-if="editCapaDialogComputed" ref="observer" v-slot="{ invalid }">
    <v-dialog
      v-model="editCapaDialogComputed"
      scrollable
      :persistent="!isInquiry"
      :max-width="400 + editShiftLists.length * 260"
    >
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ isInquiry ? $t('ELE0327') : $t('ELE0106') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text>
          <v-container fluid class="px-0 py-1">
            <v-row>
              <v-col>
                <v-card outlined>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th width="181">{{ $t('ELE0107') }}</th>
                          <th v-for="item in editShiftLists" :key="item.shiftCd">{{ item.shiftName }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ $t('ELE0108') }}</td>
                          <td class="py-1" v-for="(item, index) in editShiftLists" :key="item.shiftCd">
                            <v-row v-if="!isInquiry">
                              <v-col>
                                <TextFieldInput
                                  :label="$t('ELE0108')"
                                  v-model="editShiftLists[index].capaDimNormal"
                                  required
                                  rules="naturalNumberQty"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-else>
                              <v-col>
                                <TextFieldRef :label="$t('ELE0108')" v-model="editShiftLists[index].capaDimNormal" />
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('ELE0109') }}</td>
                          <td class="py-1" v-for="item in editShiftLists" :key="item.shiftCd">
                            <v-row v-if="!isInquiry">
                              <v-col>
                                <TextFieldInput
                                  :label="$t('ELE0109')"
                                  v-model="item.capaDimOt"
                                  required
                                  rules="naturalNumberQty"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-else>
                              <v-col>
                                <TextFieldRef :label="$t('ELE0109')" v-model="item.capaDimOt" />
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('ELE0110') }}</td>
                          <td class="py-1" v-for="item in editShiftLists" :key="item.shiftCd">
                            <v-row v-if="!isInquiry">
                              <v-col>
                                <TextFieldInput
                                  :label="$t('ELE0110')"
                                  v-model="item.totalTdm"
                                  required
                                  rules="naturalNumberQty"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-else>
                              <v-col>
                                <TextFieldRef :label="$t('ELE0110')" v-model="item.totalTdm" />
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('ELE0111') }}</td>
                          <td class="py-1" v-for="item in editShiftLists" :key="item.shiftCd">
                            <v-row v-if="!isInquiry">
                              <v-col>
                                <TextFieldInput
                                  :label="$t('ELE0111')"
                                  v-model="item.totalTms"
                                  required
                                  rules="naturalNumberQty"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-else>
                              <v-col>
                                <TextFieldRef :label="$t('ELE0111')" v-model="item.totalTms" />
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('ELE0112') }}</td>
                          <td class="py-1" v-for="item in editShiftLists" :key="item.shiftCd">
                            <v-row v-if="!isInquiry">
                              <v-col>
                                <TextFieldInput
                                  :label="$t('ELE0112')"
                                  v-model="item.capaAppNormal"
                                  required
                                  rules="naturalNumberQty"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-else>
                              <v-col>
                                <TextFieldRef :label="$t('ELE0112')" v-model="item.capaAppNormal" />
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('ELE0113') }}</td>
                          <td class="py-1" v-for="item in editShiftLists" :key="item.shiftCd">
                            <v-row v-if="!isInquiry">
                              <v-col>
                                <TextFieldInput
                                  :label="$t('ELE0113')"
                                  v-model="item.capaAppOt"
                                  required
                                  rules="naturalNumberQty"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-else>
                              <v-col>
                                <TextFieldRef :label="$t('ELE0113')" v-model="item.capaAppOt" />
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card outlined max-width="200">
                  <v-row v-if="isInquiry">
                    <v-col>
                      <TextFieldRef :label="$t('ELE0114')" :value="editCapaInspComputed" />
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col>
                      <TextFieldInput
                        :label="$t('ELE0114')"
                        v-model="editCapaInspComputed"
                        required
                        rules="naturalNumberQty"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <span class="d-flex flex-row space-between">
            <BtnClose v-if="isInquiry" @click="close" />
            <Btn v-else label="Set" @click="onClickSet" :disabled="invalid" />
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import Btn from '@/components/atoms/base/button/Btn'
import BtnSave from '@/components/atoms/button/BtnSave'
import BtnClose from '@/components/atoms/button/BtnClose'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'

export default {
  name: 'EditCapacityDialog',

  components: {
    ValidationObserver,
    Btn,
    BtnSave,
    BtnClose,
    TextFieldInput,
    TextFieldRef,
  },

  props: {
    editCapaDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    isInquiry: {
      type: Boolean,
      required: true,
    },
    editShiftLists: {
      type: Array,
      required: true,
    },
    editCapaInsp: {
      type: [String, Number],
      required: true,
    },
  },

  computed: {
    editCapaDialogComputed: {
      get() {
        return this.editCapaDialog
      },
      set(value) {
        this.$emit('update:editCapaDialog', value)
      },
    },
    editShiftListsComputed: {
      get() {
        return this.editShiftLists
      },
      set(value) {
        this.$emit('update:editShiftLists', value)
      },
    },
    editCapaInspComputed: {
      get() {
        return this.editCapaInsp
      },
      set(value) {
        this.$emit('update:editCapaInsp', value)
      },
    },
  },

  methods: {
    async close() {
      this.editCapaDialogComputed = false
    },
    async onClickSet() {
      this.$emit('set')
      this.editCapaDialogComputed = false
    },
  },
}
</script>
